import {selectCurrency, selectLanguage} from 'app/modules/auth'
import {CreatePackageSubmitRequest, CreateTicketRequest, OrderSourceSelect} from 'app/modules/tickets/models'
import {DatePackageAvailable, Worker} from 'app/modules/tickets/models/OrderDrawerModel'
import {
  clientTimeZoneOffset,
  FLOW_TYPE,
  Languages,
  PaymentMethod,
  PaymentStatus,
  DEFAULT_WORKER
} from 'app/utils/common/constants'
import { classNameFunc } from 'app/utils/helpers/components/Form'
import { ModalDialog } from 'app/utils/helpers/components/Modal'
import { isEmptyOrNull } from 'app/utils/helpers/extendMethod'
import { minuteToTime } from 'app/utils/services'
import { Form, Formik, FormikProps } from 'formik'
import { t } from 'i18next'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { HTTP_RESPONSE_STATUS } from 'setup/constants/Http'
import { useAppDispatch, useAppSelector } from 'setup/redux/Hooks'
import { ToastDefaultConfig } from 'setup/toast/ToastConfig'
import * as Yup from 'yup'
import { ticketApi } from '../redux/TicketApi'
import { BasicInfoComponent } from './components/BasicInfoComponent'
import DateTimeComponent from './components/DateTimeComponent'
import NeedServiceComponent from './components/NeededService'
import { SummaryComponent } from './components/SummaryComponent'
import { IForm } from './components/type'
import WorkerComponent from './components/WorkerComponent'
import DateTimePackage from './package-flow/DateTimeComponent/DateTimePackage'
import { initialTouched } from 'app/utils/common/constants/CreateOrderFormConfig'
import './style.scss'
import { TimeSlot } from 'app/utils/common/models'
import { selectCentroOrderSourceData, selectOrderAutomationData, ticketActions } from '../redux/TicketSlice'

export let toggleDrawer: (flag?: boolean) => void | undefined = () => { }
export interface IPropsCreateOrderDrawer { }

declare let window: any

const appendFormDataValue = (formData: FormData, key: string, value: any) => {
  if (value === undefined || value === null) {
    formData.append(key, '')
    return
  }

  if (typeof value === 'boolean') {
    formData.append(key, value ? 'true' : 'false')
    return
  }

  formData.append(key, value.toString())
}

const buildPackageSubmitFormData = (
  payload: CreatePackageSubmitRequest,
  invoiceFile?: File | null
) => {
  const formData = new FormData()
  const { tagIds, customerFavWorkerIds, deselectedFavWorkerIds, ...rest } = payload as any

  Object.entries(rest).forEach(([key, value]) => {
    if (Array.isArray(value)) return
    appendFormDataValue(formData, key, value)
  })

  if (Array.isArray(tagIds)) {
    tagIds.forEach((id) => formData.append('tagIds', id.toString()))
  }

  if (Array.isArray(customerFavWorkerIds)) {
    customerFavWorkerIds.forEach((id: string) =>
      formData.append('customerFavWorkerIds', id.toString())
    )
  }

  if (Array.isArray(deselectedFavWorkerIds)) {
    deselectedFavWorkerIds.forEach((id: string) =>
      formData.append('deselectedFavWorkerIds', id.toString())
    )
  }

  if (invoiceFile) {
    formData.append('invoiceFile', invoiceFile)
  }

  return formData
}

const generateClientRequestId = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return `dashboard-link-${window.crypto.randomUUID()}`
  }

  return `dashboard-link-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

const modalSuccess = (window.modalSuccess = (props: { onAddNew: () => void; paymentExpiryMinutes?: number | null }) => {
  const { onAddNew = () => { }, paymentExpiryMinutes = null } = props
  const onClose = () => {
    modal.current?.toggle(false)
  }
  const modal = ModalDialog({
    backdrop: 'static',
    size: 'lg',
    children: (
      <div className='create-order-success'>
        <div className='text-center'>
          <svg
            width='92'
            height='93'
            viewBox='0 0 92 93'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M66.7324 81.9888C60.431 85.6224 53.2844 87.5337 46.0104 87.5308C38.7365 87.5279 31.5914 85.6108 25.293 81.9721C18.9946 78.3335 13.7646 73.1014 10.1285 66.8015C6.49234 60.5016 4.57813 53.3557 4.57812 46.0818C4.57812 38.8079 6.49234 31.662 10.1285 25.3621C13.7646 19.0622 18.9946 13.8301 25.293 10.1915C31.5914 6.55283 38.7365 4.63574 46.0104 4.63282C53.2844 4.62989 60.431 6.54122 66.7324 10.1748C60.4286 13.8133 55.1939 19.0471 51.5543 25.3502C47.9147 31.6533 45.9986 38.8034 45.9986 46.0818C45.9986 53.3602 47.9147 60.5104 51.5543 66.8134C55.1939 73.1165 60.4286 78.3503 66.7324 81.9888Z'
              fill='#FFC20F'
            />
            <path
              d='M45.9623 92.015C37.3658 92.0089 28.9449 89.5831 21.6625 85.015C16.5428 81.8297 12.1046 77.6617 8.60443 72.7518C5.10424 67.842 2.61131 62.2876 1.26947 56.409C-0.105775 50.5332 -0.300341 44.4427 0.6972 38.4911C1.69474 32.5395 3.86456 26.8454 7.0805 21.7391C10.2607 16.6148 14.427 12.173 19.3378 8.67222C24.2487 5.17143 29.8062 2.68132 35.6874 1.34605C41.5625 -0.0266485 47.6517 -0.221509 53.6025 0.77281C59.5533 1.76713 65.2477 3.93088 70.3574 7.13902C77.8123 11.7919 83.7708 18.4916 87.5214 26.4388C91.1651 34.1598 92.5932 42.741 91.6464 51.2259C91.5823 51.8116 91.4032 52.379 91.1196 52.8954C90.8359 53.4117 90.4535 53.867 89.9936 54.2352C89.5337 54.6034 89.0053 54.8775 88.4394 55.0414C87.8735 55.2052 87.2812 55.2554 86.6957 55.1898C86.1103 55.1257 85.543 54.947 85.0268 54.6634C84.5106 54.3799 84.0555 53.9972 83.6874 53.5375C83.3193 53.0778 83.0456 52.5499 82.8818 51.9842C82.7179 51.4186 82.6669 50.8264 82.7324 50.2411C83.5031 43.4136 82.3545 36.5062 79.4155 30.2958C76.398 23.9052 71.6034 18.5195 65.6054 14.7821C57.2917 9.60046 47.2623 7.92745 37.7167 10.1297C28.1712 12.332 19.8888 18.2299 14.6855 26.5301C12.0979 30.6375 10.3517 35.2177 9.54827 40.0052C8.74489 44.7927 8.90024 49.6918 10.0053 54.4188C11.0796 59.1528 13.0836 63.6267 15.9008 67.5799C18.718 71.5332 22.2924 74.8874 26.4164 77.4481C32.4079 81.1961 39.3497 83.1444 46.4164 83.0619C53.2882 82.9779 60.0015 80.9848 65.8056 77.305C66.3023 76.9882 66.8567 76.7728 67.4369 76.6708C68.0172 76.5688 68.6115 76.5824 69.1865 76.7108C69.7614 76.8392 70.3054 77.0797 70.787 77.4188C71.2687 77.758 71.6789 78.1889 71.9936 78.6869C72.3103 79.1834 72.5259 79.7377 72.6279 80.3177C72.7298 80.8978 72.7162 81.4925 72.5878 82.0672C72.4594 82.642 72.2185 83.1858 71.8793 83.6673C71.5402 84.1489 71.1097 84.5584 70.6117 84.8729C63.3979 89.4347 55.0598 91.9064 46.5253 92.013L45.9623 92.015ZM36.0253 61.6669L24.8344 50.475C24.4166 50.0586 24.0855 49.5637 23.8593 49.0189C23.6331 48.4742 23.5165 47.8905 23.5165 47.3006C23.5165 46.7108 23.6331 46.1266 23.8593 45.5819C24.0855 45.0371 24.4166 44.5422 24.8344 44.1258C25.2507 43.708 25.7457 43.3765 26.2905 43.1503C26.8352 42.924 27.4193 42.8075 28.0092 42.8075C28.5991 42.8075 29.1827 42.924 29.7275 43.1503C30.2722 43.3765 30.7672 43.708 31.1835 44.1258L39.2006 52.1429L60.8134 30.515C61.2296 30.0967 61.7246 29.7649 62.2695 29.5384C62.8143 29.3119 63.3986 29.1952 63.9887 29.1952C64.5788 29.1952 65.1626 29.3119 65.7075 29.5384C66.2523 29.7649 66.7473 30.0967 67.1635 30.515C67.5809 30.9315 67.9122 31.4264 68.1381 31.9711C68.364 32.5157 68.4804 33.0992 68.4804 33.6888C68.4804 34.2785 68.364 34.8624 68.1381 35.4071C67.9122 35.9517 67.5809 36.4466 67.1635 36.8631L42.3754 61.6629C41.9587 62.0801 41.4635 62.4108 40.9184 62.6356C40.3733 62.8604 39.7893 62.975 39.1996 62.973C38.6107 62.9751 38.0269 62.8609 37.4824 62.6366C36.9378 62.4123 36.4429 62.0822 36.0263 61.6659L36.0253 61.6669Z'
              fill='#00171F'
            />
          </svg>
          <p className='message'>{t('CREATE_ORDER_DRAWER.SUCCESS.MESSAGE_SUCCESS')}</p>
          {typeof paymentExpiryMinutes === 'number' && paymentExpiryMinutes > 0 && (
            <p className='message message-hint'>
              {t('CREATE_ORDER_DRAWER.SUCCESS.PAYMENT_LINK_EXPIRY_HINT', { minutes: paymentExpiryMinutes })}
            </p>
          )}
          <div className='nav'>
            <button type='button' className='btn-close-modal' onClick={() => onClose()}>
              {t('CREATE_ORDER_DRAWER.SUCCESS.CLOSE')}
            </button>
            <button type='button' className='btn-add-new' onClick={() => (onClose(), onAddNew())}>
              {t('CREATE_ORDER_DRAWER.SUCCESS.ADD_NEW_ORDER')}
            </button>
          </div>
        </div>
      </div>
    ),
  })
})

const FormComponent = (props: FormikProps<IForm>) => {
  const { t } = useTranslation()
  const ref = useRef({
    timeout: 0,
  })

  const refFormHtml = useRef<HTMLFormElement>()
  const user = useAppSelector((s) => s.auth.user)

  const { errors, handleSubmit, resetForm, values, setFieldValue, setValues, setFieldTouched } = props

  const language = useAppSelector(selectLanguage)
  const rtl = language === Languages.ar

  const centroOrderSourceData = useAppSelector(selectCentroOrderSourceData);
  const [centroOrderSourceOption, setCentroOrderSourceOption] = useState<OrderSourceSelect[]>([]);
  useEffect(() => {
    if (!centroOrderSourceData) {
      return;
    }
    const tmpCentroOrderSourceOption = centroOrderSourceData.map(item => ({ value: item.id.toString(), label_En: item.titleEn, label_Ar: item.title, isActive: item.isActive, order: item.order })) as OrderSourceSelect[];
    setCentroOrderSourceOption(tmpCentroOrderSourceOption);
  }, [centroOrderSourceData])

  useEffect(() => {
    const firstService =
      values.service_selected?.[0] !== undefined ? values.service_selected?.[0] : undefined
    const isOffer = firstService?.type == 'offer'
    const offer = isOffer ? firstService : undefined

    const spIds = (
      values.service_selected?.map((e) => ('spIds' in e.data ? e.data.spIds || [] : [])).flat() ||
      []
    ).filter((e, index, arr) => arr.indexOf(e) == index)
    const subIds = isOffer ? [] : values.service_selected?.map((e) => e.parentId) || []
    const subSubIds = isOffer ? [] : values.service_selected?.map((e) => e.id) || []
    const majorId = isOffer ? offer?.data.majorId : firstService?.major_id
    const timeout = new Date().getTime()
    ref.current = { ...ref.current, timeout: timeout }
    fetchInfo(timeout, isOffer, subIds, subSubIds, spIds, majorId, offer?.id)
    return () => {
      ref.current = { ...ref.current, timeout: new Date().getTime() }
    }
  }, [(values.service_selected || []).map((e) => e.id).join(',')])

  useEffect(() => {
    if (!props.isValid && props.submitCount !== 0 && props.isSubmitting) {
      const errorElem = refFormHtml.current?.querySelectorAll(
        '.invalid-feedback'
      )?.[0] as HTMLDivElement
      const input = errorElem
        ?.closest('.has-error')
        ?.querySelectorAll('input')?.[0] as HTMLInputElement
      const errorElement = input || errorElem

      errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      errorElement?.focus({ preventScroll: true })
    }
  }, [props.submitCount, props.isValid, props.errors, props.isSubmitting])

  const fetchInfo = async (
    timeout: number,
    isOffer: boolean,
    subIds: number[],
    subSubIds: number[],
    spIds: string[],
    majorId?: number,
    offerId?: number
  ) => {
    setValues({ ...values, loadingType: 'dateTime', subSubPrices: undefined })
    const minCharge =
      subSubIds.length == 0 || isOffer || (values.location?.countryId || 0) == 0
        ? undefined
        : (
          await ticketApi.getMinCharge({
            countryId: values.location?.countryId || 0,
            subServiceIds: subIds,
          })
        ).data
          ? user?.minCharge
          : undefined
    const fee =
      (values.location?.countryId || 0) == 0 ||
        (values.main_service?.id || 0) == 0 ||
        subSubIds.length == 0
        ? undefined
        : (
          await ticketApi.getServiceFee({
            countryId: values.location?.countryId || 0,
            majorId: values.main_service?.id || 0,
            subServiceIds: subIds,
          })
        ).data
    const respTimeSlots =
      majorId === undefined
        ? undefined
        : (
          await ticketApi.getDateTimeTicket({
            clientTimeZone: clientTimeZoneOffset,
            dateCheck: moment().locale('en-US')?.format('YYYY-MM-DD') || '',
            spIds,
            majorId: majorId || 0,
            offerId,
            isPreselect: true,
          })
        ).data
    const priceDetails =
      subSubIds.length == 0 || subIds.length == 0 || (values.location?.cityId || 0) == 0
        ? undefined
        : (
          await ticketApi.getPriceSubSubService({
            cityId: values.location?.cityId || 0,
            subServiceIds: subIds,
            subSubServiceIds: subSubIds,
          })
        ).data
    if (timeout !== ref.current.timeout) return
    setValues((values) => ({
      ...values,
      loadingType: undefined,
      subSubPrices: priceDetails,
      fee,
      minCharge,
      date_time:
        respTimeSlots == undefined
          ? undefined
          : {
            ...values.date_time,
            timeSlot: respTimeSlots?.timeSlots || [],
            date:
              respTimeSlots?.selectedDate === undefined
                ? new Date()
                : typeof respTimeSlots.selectedDate === 'string'
                  ? new Date(respTimeSlots.selectedDate)
                  : respTimeSlots.selectedDate,
            time: undefined,
            customerVisitDuration: respTimeSlots?.customerVisitDuration || 0,
          },
    }))
  }

  return (
    <Form
      ref={(e: any) => (refFormHtml.current = e)}
      onSubmit={handleSubmit}
      onReset={() => resetForm()}
    >
      <Accordion
        alwaysOpen
        defaultActiveKey={['basic_info', 'need_service', 'date_time', 'worker', 'summary']}
      >
        <BasicInfoComponent index={1} rtl={rtl} formProps={props} />
        <NeedServiceComponent index={2} formProps={props} rtl={rtl} language={language} centroOrderSourceOption={centroOrderSourceOption} />
        {values.flow_type === FLOW_TYPE.PACKAGE ? (
          <>
            <WorkerComponent
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              setValues={setValues}
              index={3}
              rtl={rtl}
              language={language}
            />
            <DateTimePackage formProps={props} language={language} customerLat={values.location?.lat} customerLng={values.location?.lng} index={4} />
          </>
        ) : (
          <>
            <DateTimeComponent formProps={props} language={language} index={3} />
            <WorkerComponent
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              setValues={setValues}
              index={4}
              rtl={rtl}
              language={language}
            />
          </>
        )}
        <SummaryComponent
          rtl={rtl}
          language={language}
          index={5}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          setValues={setValues}
        />
      </Accordion>

      <button
        type='button'
        onClick={() => handleSubmit()}
        disabled={values.loadingType !== undefined}
        className='btn btn-submit mt-5'
      >
        {t('CREATE_ORDER_DRAWER.BTN_SUBMIT')}
      </button>
      <button
        type='reset'
        className='btn btn-reset mt-5'
        onClick={() => resetForm()}
        disabled={values.loadingType !== undefined}
      >
        {t('CREATE_ORDER_DRAWER.BTN_RESET')}
      </button>
      <div className='form-loading'>
        <div className='spinner-border spinner-border-sm text-dark'></div>
      </div>
    </Form>
  )
}

export const CreateOrderDrawer = (props: IPropsCreateOrderDrawer) => {
  const { t } = useTranslation()
  const currency = useAppSelector(selectCurrency)
  const language = useAppSelector(selectLanguage)
  const dispatch = useAppDispatch()

  const [state, setState] = useState({
    isOpen: false,
    isLoading: false,
  })

  const rtl = language === Languages.en
  const orderAutomationData = useAppSelector(selectOrderAutomationData)
  const isClusterLogic = useAppSelector(s => s.auth.user?.isWatanCompany)
  const refForm = useRef<FormikProps<IForm>>()
  const refBodyContent = useRef<HTMLDivElement>()

  useEffect(() => {
    toggleDrawer = (flag?: boolean) => {
      flag = flag == null ? !state.isOpen : flag
      if (flag) {
        if (window.getComputedStyle(document.body, null).overflow !== 'hidden')
          document.body.style.setProperty('overflow', 'hidden', 'important')
        refBodyContent.current?.scroll(0, 0)
      } else if (!document.body.className?.includes('modal-open')) {
        document.body.style.overflow = ''
        refForm.current?.resetForm()
      }

      setState({ ...state, isOpen: flag })
    }
  }, [state])

  useEffect(() => {
    if (state.isOpen) {
      dispatch(ticketActions.getCentroOrderSource({ id: '' }));
      dispatch(ticketActions.getOrderAutomationData());
    }
  }, [state.isOpen])

  const onSubmit = async (values: IForm) => {
    setState({ ...state, isLoading: true })
    let data
    let resp
    let dataSubmitCommon = {
      customerId: values.customer_id,
      customerLat: values.location?.lat,
      customerLng: values.location?.lng,
      cityId: values.location?.cityId,
      countryId: values.location?.countryId,
      addressId: values.addressId,
      googleMapUrl: values.map,
      customerLocationRemarks: values.location?.location,

      customerName: values.customer_name,
      phoneNumber: values.phone,
      tagIds: values.tags?.map((e) => e.id) || [],

      clientTimeZone: clientTimeZoneOffset,
      currency: currency || '',
      customerComments: values.note,
    }

    if (values.flow_type === FLOW_TYPE.PACKAGE) {
      const selected_package =
        values.listPackages && values.listPackages.find((item) => item.id === values.package)
      const number_visit = values.numberOfVisitPerWeek || 0
      const number_week = values.numberOfWeeks || 0
      let firstWeek = []

      if (number_visit === 1) {
        firstWeek = [values.selected_visit[0]]
      } else {
        for (let i = 0; i < number_visit; i++) {
          firstWeek.push(values.selected_visit[i])
        }
      }
      const selectedVisit = JSON.stringify(
        firstWeek.map((item) => ({
          scheduledVisitDateTime: `${moment(item.date)
            .locale('en-US')
            .format('MM/DD/YYYY')} ${minuteToTime(
              item?.time?.start || 0,
              true,
              true,
              Languages.en
            )} ${moment(item.date).locale('en-US').format('Z')}`,
          scheduledVisitEndDateTime:
            item?.time?.end === 1440
              ? `${moment(item.date).add(1, 'days').locale('en-US').format('MM/DD/YYYY')} ${minuteToTime(
                0,
                true,
                true,
                Languages.en
              )} ${moment(item.date).locale('en-US').format('Z')}`
              : `${moment(item.date).locale('en-US').format('MM/DD/YYYY')} ${minuteToTime(
                item?.time?.end || 0,
                true,
                true,
                Languages.en
              )} ${moment(item.date).locale('en-US').format('Z')}`,
          timeStart: item?.time?.start || 0,
          timeEnd: item?.time?.end || 0,
        }))
      )

      let numberWeekWork = 0 // it's the number of real week work (week has ticket). replace for numberOfWeek
      let weekWork = 1

      do {
        numberWeekWork++
        weekWork += values.numberOfVisitRecurrence + 1
      } while (weekWork <= number_week)

      const totalTicket = number_visit * (numberWeekWork > 0 ? numberWeekWork : number_week)

      const invoiceJson = {
        parts: [],
        fee: Number(values.total_price) / totalTicket,
        discount: 0,
        shippingCost: 0,

        package: {
          price: values.without_vat,
          priceWithVat: values.total_price,
          version: 3,
        },
        vatAmount: 0,
        vatValue: 0,
      }

      if (values.preSelectSP?.isShowVat && values.percentVAT > 0) {
        invoiceJson.vatAmount = (Number(values.total_price) - Number(values.without_vat)) / totalTicket
        invoiceJson.vatValue = values.percentVAT * 100
      }

      const invoice = JSON.stringify(invoiceJson)

      // NOTE:
      // - selected_package.preSelectSP can be stale if listPackages hasn't been refreshed after re-calling getPackageAvailable
      // - values.preSelectSP is the latest preSelectSP from API (preferred source of truth)
      const preSelectSpId = values.preSelectSP?.spId || selected_package?.preSelectSP?.spId || ''
      let spId = preSelectSpId

      // Submit rule:
      // - if a specific worker is selected => spId must be the worker's spId
      // - otherwise => spId must be preSelectSP.spId
      if (values.worker && values.worker !== DEFAULT_WORKER) {
        const foundWorker = values.worker_available?.find(
          (w): w is Worker => 'workerId' in w && w.workerId === values.worker
        )
        spId = foundWorker?.spId || preSelectSpId
      } else {
        // Check if there are multiple SPIds available and select the one matching selected time slots
        // Only for Watan company
        if (isClusterLogic) {
          const dayAvailable: DatePackageAvailable[] = values.preSelectSPBaseDayAvailable || values.preSelectSP?.dayAvailable || []
          
          if (dayAvailable.length > 0 && firstWeek.length > 0) {
            // Track which SPIds are available for each visit
            const spIdAvailabilityMap = new Map<string, number>()
            
            for (const visit of firstWeek) {
              const visitDate = moment(visit.date).startOf('day').toDate()
              const visitTimeStart = visit.time?.start || 0
              const visitTimeEnd = visit.time?.end || 0
              
              // Find matching date in dayAvailable
              const matchingDate = dayAvailable.find((day) => {
                const dayDate = moment(day.dateCheck).startOf('day').toDate()
                return moment(visitDate).isSame(dayDate, 'day')
              })
              
              if (matchingDate?.spAvaialble && matchingDate.spAvaialble.length > 1) {
                // Only check if there are multiple SPIds available
                // Find SPId that has the selected time slot available
                for (const spAvailable of matchingDate.spAvaialble) {
                  const hasTimeSlot = spAvailable.listTimes?.some((timeSlot) => {
                    return timeSlot.isAvailable && 
                           timeSlot.start <= visitTimeStart && 
                           timeSlot.end >= visitTimeEnd
                  })
                  
                  if (hasTimeSlot) {
                    const currentCount = spIdAvailabilityMap.get(spAvailable.spId) || 0
                    spIdAvailabilityMap.set(spAvailable.spId, currentCount + 1)
                  }
                }
              }
            }
            
            // If we found matching SPIds, prefer the one that matches the most visits
            // or prefer preSelectSpId if it's available
            if (spIdAvailabilityMap.size > 0) {
              if (spIdAvailabilityMap.has(preSelectSpId)) {
                spId = preSelectSpId
              } else {
                // Find SPId with highest availability count
                let maxCount = 0
                let bestSpId = ''
                spIdAvailabilityMap.forEach((count, spIdKey) => {
                  if (count > maxCount) {
                    maxCount = count
                    bestSpId = spIdKey
                  }
                })
                if (bestSpId) {
                  spId = bestSpId
                }
              }
            }
          }
        }
      }

      data = {
        ...dataSubmitCommon,

        packageId: values.package || 0,
        spId: spId,

        selectedVisit: selectedVisit,
        numOfWeek: values.numberOfWeeks || 0,
        price: Number(values.total_price) || 0,
        paymentStatus:
          PaymentStatus.find((item) => item.value === values.payment_status)?.value || '',
        paymentMethod:
          PaymentMethod.find((item) => item.value === values.payment_method)?.value || '',

        majorId: values.main_service?.id || 0,

        numberOfVisitPerWeek: values.numberOfVisitPerWeek || 0,
        numberOfVisitRecurrence: 0,
        customerVisitDuration: 0,
        invoice,
        numberOfWorker: values.number_of_workers || 0,
        preAssignWorker: !!values.worker && values.worker !== DEFAULT_WORKER ? values.worker : '',

        companyId: values.preSelectSP?.companyId || '',
        customerFavWorkerIds: values.favWorkerIds || [],

        packageServicePriceSetId: values.packageServicePriceSetId,
        packageServicePriceSetDetailId: values.packageServicePriceSetDetailId,
        isRefund: values.isRefund,
        reScheduleLimit: values.reScheduleLimit,
        ShoppingCartJson: '',
        CustomerLocation: '',
        subServiceId: values.subServiceId,
        deselectedFavWorkerIds: values.deselectedFavWorkerIds || [],

        WorkflowId: values.main_service?.data?.packageWorkFlowId || 0,
        backupNumber: values.backupNumber,
        centroSourceId: Number(values.order_source),
        nationalId: values.nationalId,
        clientRequestId: generateClientRequestId(),
      } as CreatePackageSubmitRequest

      const disabledWorker =
        values.workerConfig &&
        (!values.workerConfig.isApply ||
          (values.workerConfig.isApply && values.workerConfig.isRequireMatchWorkerNumber))

      if (!disabledWorker && values.number_of_workers !== values.workerConfig?.minWorkerAllow) {
        data.NumOfSelectWorker = values.number_of_workers
      }

      const formData = buildPackageSubmitFormData(data, values.invoiceFile || null)
      const submitResponse: any = await ticketApi
        .packageSubmitWithMeta(formData)
        .catch((e) => ({ status: -1, message: e }))

      if (submitResponse?.data) {
        resp = submitResponse.data

        const paymentMethodValue =
          PaymentMethod.find((item) => item.value === values.payment_method)?.value || ''

        if (paymentMethodValue === 'OnlinePaymentLinkSms') {
          const expireMinutesHeaderRaw = submitResponse.headers?.['x-payment-expire-minutes']
          const expireMinutesHeader = Array.isArray(expireMinutesHeaderRaw)
            ? expireMinutesHeaderRaw[0]
            : expireMinutesHeaderRaw
          let expireMinutesParsed = Number(expireMinutesHeader)

          if (!(Number.isFinite(expireMinutesParsed) && expireMinutesParsed > 0)) {
            const expiresAtHeaderRaw = submitResponse.headers?.['x-payment-expires-at']
            const expiresAtHeader = Array.isArray(expiresAtHeaderRaw)
              ? expiresAtHeaderRaw[0]
              : expiresAtHeaderRaw
            if (expiresAtHeader) {
              const expiresAtMoment = moment(expiresAtHeader)
              if (expiresAtMoment.isValid()) {
                expireMinutesParsed = Math.ceil(expiresAtMoment.diff(moment(), 'minutes', true))
              }
            }
          }

          if (Number.isFinite(expireMinutesParsed) && expireMinutesParsed > 0) {
            ;(resp as any).__paymentExpireMinutes = Math.ceil(expireMinutesParsed)
          } else {
            ;(resp as any).__paymentExpireMinutes = null
          }
        }
      } else {
        resp = submitResponse
      }
    } else {
      const firstService =
        values.service_selected?.[0] !== undefined ? values.service_selected?.[0] : undefined
      const isOffer = firstService?.type == 'offer'
      const offer = isOffer ? firstService : undefined
      data = {
        ...dataSubmitCommon,
        majorId: isOffer ? offer?.data.majorId : firstService?.major_id,
        spId: values.worker,
        visitTimeOffset:
          values.date_time && 'date' in values.date_time
            ? moment(values.date_time?.date)
              .startOf('day')
              .add(values.date_time?.time?.start || 0, 'minutes')
              .toDate()
            : undefined,
        durationTime:
          values.date_time && 'time' in values.date_time && values.date_time?.time
            ? values.date_time?.time?.end - values.date_time?.time?.start
            : 0,
        promoCode: '',
        offerId: isOffer ? offer?.id : null,

        shoppingCart:
          values.service_selected?.map((e) => {
            if (
              e.type == 'offer' &&
              e.data.expiredDate &&
              moment(e.data.expiredDate).startOf('day').diff(moment().startOf('day'), 'seconds') < 0
            )
              return null

            return {
              id: e.type == 'sub_sub' ? e.data_sub.id : undefined,
              subSubServices: [
                {
                  id: e.type == 'sub_sub' ? e.id : undefined,
                  quantity: e.type == 'sub_sub' ? e.quantity : undefined,
                },
              ],
            }
          }) || [],
        isUseDelivery: false,
        backupNumber: values.backupNumber,
        nationalId: values.nationalId,
      } as CreateTicketRequest

      resp = await ticketApi.createTicket(data).catch((e) => ({ status: -1, message: e }))
    }

    if (resp.status !== HTTP_RESPONSE_STATUS.SUCCESS) {
      toast.error(resp.message, ToastDefaultConfig())
      setState({ ...state, isLoading: false })
      return
    }
    refForm.current?.resetForm()
    setState({ ...state, isLoading: false, isOpen: false })
    const isPaymentLink = values.payment_method === 'OnlinePaymentLinkSms'
    const headerExpireMinutes: number | null = (resp as any).__paymentExpireMinutes ?? null
    const configuredExpireMinutes: number | null =
      typeof orderAutomationData?.paymentLinkExpirationMinutes === 'number' &&
      orderAutomationData.paymentLinkExpirationMinutes > 0
        ? orderAutomationData.paymentLinkExpirationMinutes
        : null
    modalSuccess({
      onAddNew: () => toggleDrawer(true),
      paymentExpiryMinutes: isPaymentLink ? (headerExpireMinutes ?? configuredExpireMinutes) : null,
    })
  }

  function isValidNationalId(value: string): boolean {
    // Check Luhn Algorithm
    const digits = value.toString().split('').map(Number);

    let sum = 0;
    let isAlternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = digits[i];

      if (isAlternate) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      isAlternate = !isAlternate;
    }

    return sum % 10 === 0;
  };

  const validator = Yup.object().shape({
    //basic
    phone: Yup.string()
      .required('CREATE_ORDER_DRAWER.SECTION_1.VALID.PHONE_AR')
      .phoneAr('CREATE_ORDER_DRAWER.SECTION_1.VALID.PHONE_AR'),
    customer_name: Yup.string()
      .required('CREATE_ORDER_DRAWER.SECTION_1.VALID.NAME_REQUIRE')
      .min(2, 'CREATE_ORDER_DRAWER.SECTION_1.VALID.NAME_REQUIRE')
      .max(50)
      .matches(
        /^([a-zA-Z]+\s)*[a-zA-Z]+$|^[\u0621-\u064A+\s]*[\u0621-\u064A]+$/,
        'CREATE_ORDER_DRAWER.SECTION_1.VALID.NAME_REQUIRE'
      ),
    nationalId: Yup.string()
      .matches(/^\d*$/, 'CREATE_ORDER_DRAWER.SECTION_1.VALID.NATIONAL_ID_FORMAT')
      .test(
        'national-id-length',
        'CREATE_ORDER_DRAWER.SECTION_1.VALID.NATIONAL_ID_LENGTH',
        (value) => {
          if (!value || value.length === 0) return true;
          return value.length === 10;
        }
      )
      .test(
        'national-id-prefix',
        'CREATE_ORDER_DRAWER.SECTION_1.VALID.NATIONAL_ID_PREFIX',
        (value) => {
          if (!value || value.length === 0) return true;
          return value.startsWith('1') || value.startsWith('2');
        }
      )
      .test(
        'national-id-validation',
        'CREATE_ORDER_DRAWER.SECTION_1.VALID.NATIONAL_ID_VALID',
        (value) => {
          if (!value || value.length === 0) return true;
          return isValidNationalId(value);
        }
      ),
    type: Yup.string(),
    tags: Yup.array(),

    backupNumber: Yup.string().phoneAr('CREATE_ORDER_DRAWER.SECTION_1.VALID.PHONE_FORMAT'),

    map: Yup.string()
      .required('CREATE_ORDER_DRAWER.SECTION_1.VALID.MAP_AR')
      .test({
        name: 'map',
        test: (val, { parent, createError }) => {
          return parent.mapError
            ? createError({
              message: parent.mapError,
              path: 'map',
            })
            : true
        },
      })
      .max(1000),

    note: Yup.string().max(240, 'CREATE_ORDER_DRAWER.SECTION_1.VALID.NOTE_AR'),

    //service
    service_selected: Yup.array().when('main_service', {
      is: (main_service: IForm['main_service'], service_available: IForm['service_available']) =>
        isEmptyOrNull(main_service) &&
        isEmptyOrNull(service_available) &&
        isEmptyOrNull(service_available?.major) &&
        isEmptyOrNull(service_available?.offer),
      then: (schema) => schema.requireArray('CREATE_ORDER_DRAWER.SECTION_2.VALID.SERVICE-service'),
      otherwise: (schema) =>
        schema.when('main_service', {
          is: (main_service: IForm['main_service']) => main_service?.type === 'service_offer',
          then: (schema) =>
            schema.requireArray('CREATE_ORDER_DRAWER.SECTION_2.VALID.OFFER-service_offer'),
          otherwise: (schema) =>
            schema.when('main_service', {
              is: (main_service: IForm['main_service']) => main_service?.type === 'service',
              then: (schema) =>
                schema.when('sub_service', {
                  is: (sub_service: IForm['sub_service']) => sub_service?.length === 0,
                  then: (schema) =>
                    schema.requireArray('CREATE_ORDER_DRAWER.SECTION_2.VALID.SUB_SERVICE-sub'),
                  otherwise: (schema) =>
                    schema.requireArray(
                      'CREATE_ORDER_DRAWER.SECTION_2.VALID.SUB_SUB_SERVICE-sub_sub'
                    ),
                }),
            }),
        }),
    }),
    service_type: Yup.string(),

    //package_flow
    package: Yup.number().when(['main_service', 'listPackages'], {
      is: (main_service: IForm['main_service'], listPackages: IForm['listPackages']) =>
        main_service?.type === 'package_service' && !!listPackages?.length,
      then: (schema) => schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.PACKAGE_REQUIRED'),
      otherwise: (schema) =>
        schema.when('main_service', {
          is: (main_service: IForm['main_service'], listPackages: IForm['listPackages']) =>
            main_service?.type === 'package_service' && !listPackages?.length,
          then: (schema) =>
            schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.PACKAGE_UNAVAILABLE'),
        }),
    }),

    number_of_workers: Yup.number().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) =>
        schema
          .required('CREATE_ORDER_DRAWER.SECTION_2.VALID.NUMBER_OF_WORKER')
          .max(
            Yup.ref('maxWorker'),
            t('CREATE_ORDER_DRAWER.SECTION_2.VALID.NUMBER_OF_WORKER_MAX', {
              value: refForm?.current?.values?.maxWorker,
            })
          )
          .min(
            Yup.ref('workerConfig.minWorkerAllow'),
            t('CREATE_ORDER_DRAWER.SECTION_2.VALID.NUMBER_OF_WORKER_MIN', {
              value: refForm?.current?.values?.workerConfig?.minWorkerAllow,
            })
          ),
    }),

    without_vat: Yup.number().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) =>
        schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.PRICE_WITHOUT_VAT_REQUIRED'),
    }),

    total_price: Yup.number().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) => schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.TOTAL_PRICE_REQUIRED'),
    }),

    payment_method: Yup.string().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) => schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.PAYMENT_METHOD'),
    }),

    payment_status: Yup.string().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) => schema.required('CREATE_ORDER_DRAWER.SECTION_2.VALID.PAYMENT_STATUS'),
    }),

    order_source: Yup.string().when('package', {
      is: (selected_package: IForm['package']) => !!selected_package,
      then: (schema) => schema.required(t('CREATE_ORDER_DRAWER.SECTION_2.VALID.ORDER_SOURCE')),
    }),
    //datetime
    date_time: Yup.lazy((value) =>
      value && value.length
        ? Yup.array(
          Yup.object().shape({
            date: Yup.date().required('CREATE_ORDER_DRAWER.SECTION_3.VALID.DATE'),
            time: Yup.object().when('date', {
              is: (
                values: NonNullable<{
                  date?: Date
                  time?: TimeSlot
                  timeSlot?: TimeSlot[]
                  customerVisitDuration?: number
                }>['date']
              ) => values !== undefined,
              then: (schema) => schema.required(t('CREATE_ORDER_DRAWER.SECTION_3.VALID.TIME')),
            }),
          })
        ).min(Yup.ref('totalVisit'), t('CREATE_ORDER_DRAWER.SECTION_3.VALID.NOT_ENOUGH'))
        : Yup.object()
          .requiredObj('CREATE_ORDER_DRAWER.SECTION_3.VALID.DATE')
          .shape({
            date: Yup.date().required('CREATE_ORDER_DRAWER.SECTION_3.VALID.DATE'),
            time: Yup.object().when('date', {
              is: (
                values: NonNullable<{
                  date?: Date
                  time?: TimeSlot
                  timeSlot?: TimeSlot[]
                  customerVisitDuration?: number
                }>['date']
              ) => values !== undefined,
              then: (schema) => schema.required(t('CREATE_ORDER_DRAWER.SECTION_3.VALID.TIME')),
            }),
          })
    ),

    //worker
    worker: Yup.string().required('CREATE_ORDER_DRAWER.SECTION_4.VALID.SELECT_WORKER'),
  })

  const defaultValue: { [P in keyof IForm]+?: IForm[P] } = {
    phone: '',
    customer_name: '',
    tags: [],
    map: '',
    address: '',
    street: '',
    building: '',
    backupNumber: '',
    note: '',
    nationalId: '',
    addressId: '',

    main_service: undefined,
    service_selected: undefined,
    flow_type: '',
    sub_service: [],
    package: undefined,
    number_of_workers: 0,
    percentVAT: 0,

    favWorkerIds: [],
    worker_available: [],
    worker: undefined,
    payment_method: 'OnlinePaymentLinkSms',
    payment_status: 'pending',
    order_source: '',
    invoiceFile: null,
    invoicePreviewUrl: null,
    date_time: undefined,
  }

  return (
    <div
      className={classNameFunc([
        'drawer-create-order',
        state.isOpen && '--open',
        state.isLoading && '--loading',
      ])}
    >
      <div className='backdrop' onClick={() => toggleDrawer?.(false)}></div>
      <div className={classNameFunc([`drawer-content`, rtl && 'rtl'])}>
        <div className='drawer-header'>
          <p>{t('CREATE_ORDER_DRAWER.TITLE')}</p>
          <button type='button' onClick={() => toggleDrawer?.(false)}>
            <svg
              width='15'
              height='17'
              viewBox='0 0 15 17'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M14.3296 13.9633L9.64638 8.71094L14.3296 3.45855C14.5781 3.17987 14.7177 2.8019 14.7177 2.40779C14.7177 2.01368 14.5781 1.63571 14.3296 1.35703C14.0812 1.07835 13.7441 0.921788 13.3927 0.921788C13.0413 0.921788 12.7043 1.07835 12.4558 1.35703L7.77257 6.60942L3.0893 1.35703C2.84082 1.07835 2.5038 0.921788 2.1524 0.921788C1.80099 0.921788 1.46397 1.07835 1.21549 1.35703C0.967008 1.63571 0.827411 2.01368 0.827411 2.40779C0.827411 2.8019 0.967008 3.17987 1.21549 3.45855L5.89876 8.71094L1.21549 13.9633C0.967008 14.242 0.827411 14.62 0.827411 15.0141C0.827411 15.4082 0.967008 15.7862 1.21549 16.0648C1.46397 16.3435 1.80099 16.5001 2.1524 16.5001C2.5038 16.5001 2.84082 16.3435 3.0893 16.0648L7.77257 10.8125L12.4558 16.0648C12.7043 16.3435 13.0413 16.5001 13.3927 16.5001C13.7441 16.5001 14.0812 16.3435 14.3296 16.0648C14.5781 15.7862 14.7177 15.4082 14.7177 15.0141C14.7177 14.62 14.5781 14.242 14.3296 13.9633Z'
                fill='#00171F'
              />
            </svg>
          </button>
        </div>
        <div ref={(e: any) => (refBodyContent.current = e)} className='drawer-body'>
          {state.isOpen && (
            <Formik<IForm>
              initialValues={defaultValue as IForm}
              validationSchema={validator}
              initialTouched={initialTouched}
              validateOnChange
              onSubmit={onSubmit}
            >
              {(props) => {
                refForm.current = props
                return <FormComponent {...props} key={'FormComponent'} />
              }}
            </Formik>
          )}
        </div>
      </div>
    </div>
  )
}
